module.exports = __webpack_public_path__ + "img/traffic-cone.7dfe19bf.svg";